<template>
  <div class="content">
    <div class="inner_content">
      <el-form ref="form" :model="type" label-width="180px">
        <el-form-item label="是否享受会员折扣">
          <!-- <el-switch v-model="form.delivery"></el-switch> -->
          <el-radio-group v-model="type.user_level">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否享受优惠券">
          <!-- <el-switch v-model="form.delivery"></el-switch> -->
          <el-radio-group v-model="type.coupon_status">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否享受积分抵扣">
          <!-- <el-switch v-model="form.delivery"></el-switch> -->
          <el-radio-group v-model="type.points_status">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员折扣与充值优惠同享">
          <el-radio-group
            v-model="type.recharge_discount"
            @change="secelt_radio"
          >
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
          <div v-if="type.recharge_discount == 0">
            <el-form-item label="会员折扣与充值锁油价同享">
              <el-radio-group v-model="type.recharge_lock_discount">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="会员折扣与充值每升减同享">
              <el-radio-group v-model="type.recharge_unify_discount">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <div v-if="type.recharge_discount == 0">
            <div>油品选项列表</div>
            <el-checkbox-group v-model="recharge_discount_type">
              <el-checkbox
                v-for="item in good_types"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="优惠券抵扣与充值优惠同享">
          <el-radio-group v-model="type.recharge_coupon">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="积分抵扣与充值优惠同享">
          <el-radio-group v-model="type.recharge_point">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="plarmy" @click="setId" size="small">确定</el-button>
        </el-form-item>
      </el-form>
      <div class="bottom"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { balanceData, balanceStatus } from "@/api/pay";
import { getOilSortList } from "@/api/vip";

export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  data() {
    return {
      type: {
        user_level: 1,
        coupon_status: 1,
        points_status: 1,
        recharge_discount: 1,
        recharge_coupon: 1,
        recharge_point: 1,
        recharge_unify_discount: 1,
        recharge_lock_discount: 1,
      },
      recharge_discount_type: [],
      good_types: [],
    };
  },
  mounted() {
    this.get_OilSortList();
  },
  methods: {
    secelt_radio(val) {
      let arr = [];
      if (val == 1) {
        this.type.recharge_unify_discount = 1;
        this.type.recharge_lock_discount = 1;
      }
      if (val == 0 && this.type.recharge_discount_type === undefined) {
        this.good_types.forEach((item) => {
          arr.push(Number(item.id));
        });
        this.recharge_discount_type = arr;
      }
    },
    getData() {
      // this.page++;
      let data = {
        token: this.token,
        app_id: this.app_id,
        // page: this.page,
      };
      balanceData(data).then((res) => {
        console.log("unionData222: ", res);
        if (res.code == 200) {
          this.type = JSON.parse(res.data.type);
          if (this.type.recharge_discount_type) {
            this.recharge_discount_type = JSON.parse(res.data.type)
              .recharge_discount_type.split(",")
              .map(Number);
          }
          // console.log(this.type)
          if (this.type.recharge_discount == 0) {
            console.log("1");
            if (!this.type.hasOwnProperty("recharge_discount_type")) {
              console.log(2);
              this.good_types.forEach((item) => {
                this.recharge_discount_type.push(Number(item.id));
              });
              console.log("88", this.good_types);
            }
          }
        } else {
          this.$message.warning(res.msg);
        }
        console.log(
          this.type.recharge_discount,
          this.type.recharge_discount_type
        );

        console.log(this.recharge_discount_type);
      });
    },
    get_OilSortList() {
      getOilSortList(this.token, this.app_id).then((res) => {
        if (res.code == 200) {
          this.good_types = res.data;
          this.getData();
        }
      });
    },
    // 设置
    setId() {
      // this.page++;
      if (this.type.recharge_discount == 0) {
        this.type.recharge_discount_type = this.recharge_discount_type.join(
          ","
        );
      }
      let data = {
        token: this.token,
        app_id: this.app_id,
        type: JSON.stringify(this.type),
      };
      balanceStatus(data).then((res) => {
        console.log("设置数据", res);
        if (res.code == 200) {
          this.$message.success("修改成功");
          this.reload();
        } else {
          this.$message(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  border: 1px solid #f1f1f1;
  overflow-y: auto;
  min-width: 900px;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 24px 24px 0;
    height: 100%;
    .zhifubao-top {
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 0px;
}
.flxedWidth {
  width: 140px;
}
.color-red {
  color: red;
  padding-right: 10px;
}
.color-blue {
  color: #409eff;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
